module.exports = __webpack_public_path__ + "img/li.d737b132.jpg";